export default __webpack_public_path__ + "50d2c19010b56242cd12f2e9126a647d.png";